import styled from "styled-components"
import theme from "../../../theme"


export const Separator = styled.section`
  display: flex;
  justify-content: center;
  background: ${theme.bg.alt};
  width: 100%;
  margin-bottom: 64px;
  border-top-width: 5px;
  border-top-style: solid;
  border-image-slice: 1;
  border-image-source: linear-gradient(to right, 
      ${theme.brand.default}, 
      ${theme.brand.alt},
      ${theme.brand.default} 
    );
  box-shadow: 0 10px 10px -7px rgba(0,0,0,.2);`

export const SeparatorContainer = styled.div`
  display: flex;
  flex-direction:  column;
  color: ${theme.text.default};
  align-items: flex-start;
  justify-content: center;
  max-width: 1440px;
  padding: 20px;
  
  @media (min-width: 1024px) {
    flex-direction: row;
  }
`


export const SeparatorText = styled.div`
  line-height: 1.47059;
  font-size: 1rem;
  color: ${theme.text.placeholder};
  font-weight: 400;
  letter-spacing: -.022em;
  padding: 24px 16px;
  
  & > p {
    margin: 0 0 8px 0;
  }

  @media (min-width: 1024px) {
     max-width: 50%;
     padding: 32px 16px;
  }
`

export const SeparatorHeader = styled.div`
  padding: 16px;
  
  @media (min-width: 1024px) {
     max-width: 50%;
  }
  
  & > h1{
    font-size: 2rem;
    background-image:linear-gradient(90deg,${theme.brand.default},${theme.brand.alt},${theme.brand.default});
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    color: ${theme.text.default};
    font-weight: 600;
    line-height: 1.2;
    letter-spacing: -.015em;
    margin: 0 0 8px 0;
  }
  
  & > h2{
    font-size: 1.4rem;
    color: ${theme.text.alt};
    font-weight: 600;
    line-height: 1.2;
    letter-spacing: -.015em;
    margin: 0;
  }
`
